import React from 'react';

var VARIANTS = {
  FOR_SALE: 'FOR_SALE',
  PRE_MARKET: 'PRE_MARKET',
  FOR_RENT: 'FOR_RENT',
  NEW_CONSTRUCTION: 'NEW_CONSTRUCTION',
  SHOWCASE: 'SHOWCASE',
  // Shopper platform
  FOR_SALE_SHOPPER_PLATFORM: 'FOR_SALE_SHOPPER_PLATFORM',
  NOT_FOR_SALE_SHOPPER_PLATFORM: 'NOT_FOR_SALE_SHOPPER_PLATFORM',
  // used for both off-market and recently sold
  FOR_RENT_SHOPPER_PLATFORM: 'FOR_RENT_SHOPPER_PLATFORM',
  PAID_BUILDER_SHOPPER_PLATFORM: 'PAID_BUILDER_SHOPPER_PLATFORM'
};
var HOME_STATUSES = {
  FOR_SALE: 'FOR_SALE',
  FORECLOSED: 'FORECLOSED',
  MMM: 'MMM',
  OTHER: 'OTHER',
  PENDING: 'PENDING',
  PRE_FORECLOSURE: 'PRE_FORECLOSURE',
  FOR_RENT: 'FOR_RENT',
  SOLD: 'SOLD',
  RECENTLY_SOLD: 'RECENTLY_SOLD'
};

var variantQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "VariantQuery"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "zpid"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "altId"
        }
      },
      "type": {
        "kind": "NamedType",
        "name": {
          "kind": "Name",
          "value": "ID"
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "property"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "zpid"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "zpid"
            }
          }
        }, {
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "palsId"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "altId"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "isPremierBuilder"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "homeStatus"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "listing_sub_type"
            },
            "arguments": [],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_FSBO"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_FSBA"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_newHome"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_foreclosure"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_bankOwned"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_forAuction"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "is_comingSoon"
                },
                "arguments": [],
                "directives": []
              }]
            }
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "zpid"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 208,
    "source": {
      "body": "query VariantQuery($zpid:ID!$altId:ID){property(zpid:$zpid palsId:$altId){isPremierBuilder homeStatus listing_sub_type{is_FSBO is_FSBA is_newHome is_foreclosure is_bankOwned is_forAuction is_comingSoon}zpid}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};

function validateZpid(zpid) {
  var zpidRegex = /^\d+$/;

  if (!zpid) {
    throw new Error('Invalid Argument: zpid must be provided');
  }

  if (!zpidRegex.test(zpid)) {
    throw new Error("Invalid Argument: zpid must be a string of numbers, but was '" + zpid + "'");
  }
}

function getVariant(_ref) {
  return new Promise(function ($return, $error) {
    var zpid = _ref.zpid,
        altId = _ref.altId,
        graphqlClient = _ref.graphqlClient;
    validateZpid(zpid);
    var abTests = {
      SPT_RENDER_FOR_SALE_PAGE: 'ON'
    };
    return $return(graphqlClient.query({
      query: variantQuery,
      variables: {
        zpid: zpid,
        altId: altId
      }
    }).then(function (_ref2) {
      var _ref2$data = _ref2.data;
      _ref2$data = _ref2$data === void 0 ? {} : _ref2$data;
      var property = _ref2$data.property;

      if (!property.zpid) {
        throw new Error("Property Not Found: no property found for zpid '" + zpid + "'");
      }

      return variantForType(property, abTests);
    }));
  });
}

var ForSalePackageContext = /*#__PURE__*/React.createContext();
// https://bitbucket.zgtools.net/projects/LIBS/repos/home-details-ab-logic/browse/src/main/java/com/zillow/web/logic/homedetails/HomeDetailsServiceABLogic.java#1260

var STATES_FOR_SEO_TESTS = {
  WA: 'WA',
  OR: 'OR',
  CA: 'CA',
  NV: 'NV',
  ID: 'ID',
  MT: 'MT',
  WY: 'WY',
  UT: 'UT',
  AZ: 'AZ',
  NM: 'NM',
  CO: 'CO',
  TX: 'TX',
  OK: 'OK',
  AR: 'AR',
  LA: 'LA',
  MS: 'MS',
  AL: 'AL',
  GA: 'GA',
  FL: 'FL',
  AK: 'AK',
  HI: 'HI'
};
var LISTING_SUBTYPES = {
  AUCTION: 'is_forAuction',
  BANK_OWNED: 'is_bankOwned',
  COMING_SOON: 'is_comingSoon',
  FORECLOSURE: 'is_foreclosure',
  FSBO: 'is_FSBO',
  NEW_CONSTRUCTION: 'is_newHome',
  FSBA: 'is_FSBA'
};
/*
 * Function that returns boolean if a property is considered
 * "not for sale," ie sold, recently sold, and off-market homes.
 */

var isNFS = function isNFS(homeStatus) {
  return homeStatus === HOME_STATUSES.RECENTLY_SOLD || homeStatus === HOME_STATUSES.SOLD || homeStatus === HOME_STATUSES.OTHER;
};
/*
 * Function that returns a boolean if a property is for-sale-by-agent or not.
 */

var isFSBA = function isFSBA(homeStatus, listingSubtype) {
  return homeStatus === HOME_STATUSES.FOR_SALE && listingSubtype[LISTING_SUBTYPES.FSBA];
};
/*
 * New construction homes have a homeStatus of "FOR_SALE" or "PENDING"
 * and a listing_sub_type.is_newHome = true.
 */

var isNC = function isNC(homeStatus, listingSubtype) {
  if (listingSubtype === void 0) {
    listingSubtype = {};
  }

  return [HOME_STATUSES.FOR_SALE, HOME_STATUSES.PENDING].indexOf(homeStatus) >= 0 && listingSubtype[LISTING_SUBTYPES.NEW_CONSTRUCTION] === true;
};
/*
 * DEPRECATED: This function has been replaced by a "isPremierBuilder" function in
 * the `new-construction-variant` that checks for paid NC, link:
 * https://bitbucket.zgtools.net/projects/FE/repos/new-construction-home-details-components/browse/packages/new-construction-variant/src/index.js#53-55
 *
 * New construction homes (in general) have a listing_sub_type.is_newHome = true.
 * The function below checks if a property is a *paid* new-con home (isPremierBuilder=true).
 * A better name for this function would be "isPaidNewConstruction" but updating all the
 * references to this function requires more work than it's worth.
 */

var isNewConstruction = function isNewConstruction(property) {
  if (!property) {
    throw new Error('Property was null!');
  }

  if (!property.listing_sub_type) {
    return false;
  }

  var isPaidNCType = property.isPremierBuilder === true;
  return isNC(property.homeStatus, property.listing_sub_type) && isPaidNCType;
}; // This includes FSBA, Zillow-owned FSBA, Zillow-owned Coming Soon, FSBO, Auction, FS Foreclosure,
// Preforeclosure, Pending, Coming Soon, New Construction FSBA HDPs.

function isForSaleVariant(homeStatus, listingSubtype) {
  var isComingSoon = listingSubtype && listingSubtype[LISTING_SUBTYPES.COMING_SOON];
  var isForSale = homeStatus === HOME_STATUSES.FOR_SALE;
  var isPending = homeStatus === HOME_STATUSES.PENDING;
  var isPreforeclosure = homeStatus === HOME_STATUSES.PRE_FORECLOSURE;
  var isForeclosure = homeStatus === HOME_STATUSES.FORECLOSED;
  var isNewCon = listingSubtype && listingSubtype[LISTING_SUBTYPES.NEW_CONSTRUCTION];

  if (!isForSale && !isPending && !isComingSoon && !isPreforeclosure && !isForeclosure) {
    return false;
  }

  return !!(isFSBA(homeStatus, listingSubtype) || isComingSoon || isPending || isPreforeclosure || isForeclosure || listingSubtype[LISTING_SUBTYPES.FSBO] || listingSubtype[LISTING_SUBTYPES.AUCTION] || listingSubtype[LISTING_SUBTYPES.FORECLOSURE] || listingSubtype[LISTING_SUBTYPES.BANK_OWNED] || isNewCon);
} // Includes all for-sale, coming soon, or pending listings with the showcase flag set to true


function isShowcaseVariant(_ref) {
  var listingSubtype = _ref.listingSubtype,
      isShowcaseListing = _ref.isShowcaseListing;
  var isFSBO = listingSubtype && listingSubtype[LISTING_SUBTYPES.FSBO]; // Prevent the case of someone buying a showcase listing
  // then immediately seeling the property FSBO, and the showcase flag still being true.

  if (isFSBO) {
    return false;
  }

  return !!isShowcaseListing;
}

var variantFragment = {
  "kind": "Document",
  "definitions": [{
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "Variant_property"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "Property"
      }
    },
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "isShowcaseListing"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "isPremierBuilder"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "homeStatus"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "listing_sub_type"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_FSBO"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_FSBA"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_newHome"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_foreclosure"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_bankOwned"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_forAuction"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "is_comingSoon"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "zpid"
        },
        "arguments": [],
        "directives": []
      }, {
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "state"
        },
        "arguments": [],
        "directives": []
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 195,
    "source": {
      "body": "fragment Variant_property on Property{isShowcaseListing isPremierBuilder homeStatus listing_sub_type{is_FSBO is_FSBA is_newHome is_foreclosure is_bankOwned is_forAuction is_comingSoon}zpid state}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var variantABTestsFragment = {
  "kind": "Document",
  "definitions": [{
    "kind": "FragmentDefinition",
    "name": {
      "kind": "Name",
      "value": "Variant_abTests"
    },
    "typeCondition": {
      "kind": "NamedType",
      "name": {
        "kind": "Name",
        "value": "ABTests"
      }
    },
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "alias": {
          "kind": "Name",
          "value": "SPT_RENDER_FOR_SALE_PAGE"
        },
        "name": {
          "kind": "Name",
          "value": "abTest"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "trial"
          },
          "value": {
            "kind": "StringValue",
            "value": "SPT_RENDER_FOR_SALE_PAGE",
            "block": false
          }
        }],
        "directives": []
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 102,
    "source": {
      "body": "fragment Variant_abTests on ABTests{SPT_RENDER_FOR_SALE_PAGE:abTest(trial:\"SPT_RENDER_FOR_SALE_PAGE\")}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
}; // Spec for Wow HDP a/b buckets https://zwiki.zillowgroup.net/display/zproddev/New+WOW+AB+buckets

function variantDataForType(_temp, abTests) {
  var _ref2 = _temp === void 0 ? {} : _temp,
      homeStatus = _ref2.homeStatus,
      homeStatusForHDP = _ref2.homeStatusForHDP,
      isPremierBuilder = _ref2.isPremierBuilder,
      listingSubtype = _ref2.listing_sub_type,
      isShowcaseListing = _ref2.isShowcaseListing;

  // homeStatusForHDP takes precedence over homeStatus
  var homeStatusOfTruth = Object.values(HOME_STATUSES).indexOf(homeStatusForHDP) > -1 ? homeStatusForHDP : homeStatus; // New construction premier builder / Paid builder

  if (isPremierBuilder && [HOME_STATUSES.FOR_SALE, HOME_STATUSES.PENDING].indexOf(homeStatusOfTruth) >= 0 && listingSubtype[LISTING_SUBTYPES.NEW_CONSTRUCTION]) {
    return {
      variant: VARIANTS.PAID_BUILDER_SHOPPER_PLATFORM
    };
  }

  if (isShowcaseVariant({
    listingSubtype: listingSubtype,
    isShowcaseListing: isShowcaseListing
  })) {
    return {
      variant: VARIANTS.SHOWCASE
    };
  } // Handle all for-sale types


  if (isForSaleVariant(homeStatusOfTruth, listingSubtype)) {
    return {
      variant: VARIANTS.FOR_SALE_SHOPPER_PLATFORM
    };
  } // Recently sold and off-market


  if (isNFS(homeStatusOfTruth)) {
    var variant = VARIANTS.NOT_FOR_SALE_SHOPPER_PLATFORM;
    return {
      variant: variant
    };
  } // For rent


  if (homeStatusOfTruth === HOME_STATUSES.FOR_RENT) {
    var isForRentShopperPlatform = abTests && abTests.SPT_RENDER_FOR_RENT_PAGE === 'ON';

    var _variant = isForRentShopperPlatform ? VARIANTS.FOR_RENT_SHOPPER_PLATFORM : VARIANTS.FOR_RENT;

    return {
      variant: _variant
    };
  } // If no variant was assigned, fall back to FOR_SALE. This theoretically shouldn't happen,
  // so log in case there are cases that are missing above.


  console.warn('No variant assigned, falling back to FS Shopper platform. HomeStatus:', homeStatusOfTruth, ', listingSubtype:', JSON.stringify(listingSubtype));
  return {
    variant: VARIANTS.FOR_SALE_SHOPPER_PLATFORM,
    isDoubleScroll: true
  };
}

function variantForType(homeInfo, abTests) {
  if (homeInfo === void 0) {
    homeInfo = {};
  }

  return variantDataForType(homeInfo, abTests).variant;
}

export { ForSalePackageContext, HOME_STATUSES, LISTING_SUBTYPES, STATES_FOR_SEO_TESTS, VARIANTS, getVariant, isFSBA, isNC, isNFS, isNewConstruction, variantABTestsFragment, variantForType, variantFragment };
